<template>
  <SectionRowContainer class="notfound-container">
    <b-col md="1"></b-col>

    <b-col md="5">
      <h1><b>404</b></h1>
      <h3><b>PAGE NOT FOUND!</b></h3>

      <p>
        The page you are looking for does not seem to exist. Please check your link
        again or visit any of our pages below.
      </p>

      <div
        v-for="navItem in navUrls"
        :key="navItem.text"
      >
        <b-link
          :href="navItem.url"
          :target="navItem.isTargetBlank ? '_blank' : ''"
        >
          {{ navItem.text }}
        </b-link>
      </div>
    </b-col>

    <b-col></b-col>
  </SectionRowContainer>
</template>

<script>
import SectionRowContainer from '../components/layout/SectionRowContainer.vue';

import navUrls from '../assets/data/nav-urls.json';

export default {
  name: 'NotFoundPage',
  components: {
    SectionRowContainer
  },
  data() {
    return {
      navUrls
    };
  }
}
</script>

<style lang="scss" scoped>
.notfound-container {
  margin-top: 50px;

  h1 {
    font-size: 100px;
  }
}

@media (max-width: $mediaXsWidth) {
  .notfound-container {
    margin-top: 0px;
  }
}
</style>
